import { render, staticRenderFns } from "./CalculatingDeckSpaceNotification.vue?vue&type=template&id=34973758&"
import script from "./CalculatingDeckSpaceNotification.vue?vue&type=script&lang=js&"
export * from "./CalculatingDeckSpaceNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports